import ImageAnswer from 'models/task/question/answer/ImageAnswer';
import TextAnswer from 'models/task/question/answer/TextAnswer';

export default {
	image: ImageAnswer,
	text: TextAnswer,
};
